(function () {
  function initModes(root) {
    root.querySelectorAll('[data-og-modes]').forEach(function (section) {
      if (section.dataset.ogReady === 'true') return;
      section.dataset.ogReady = 'true';

      var tabs = Array.from(section.querySelectorAll('[data-og-tab]'));
      var panels = Array.from(section.querySelectorAll('[data-og-panel]'));

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.dataset.ogTab;

          tabs.forEach(function (item) {
            var active = item === tab;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', active ? 'true' : 'false');
            item.setAttribute('tabindex', active ? '0' : '-1');
          });

          panels.forEach(function (panel) {
            panel.hidden = panel.dataset.ogPanel !== target;
          });
        });
      });
    });
  }

  function initTroubleshooting(root) {
    root.querySelectorAll('[data-og-troubleshooting]').forEach(function (section) {
      if (section.dataset.ogReady === 'true') return;
      section.dataset.ogReady = 'true';

      var buttons = Array.from(section.querySelectorAll('[data-og-problem]'));
      var answers = Array.from(section.querySelectorAll('[data-og-answer]'));

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          var target = button.dataset.ogProblem;

          buttons.forEach(function (item) {
            var active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-expanded', active ? 'true' : 'false');
            var status = item.querySelector('small');
            if (status) status.textContent = active ? 'Selected' : 'View fix';
          });

          answers.forEach(function (answer) {
            answer.hidden = answer.dataset.ogAnswer !== target;
          });
        });
      });
    });
  }

  function init(root) {
    initModes(root || document);
    initTroubleshooting(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
